import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Organization } from './organization.model';

import * as ACTIONS from './organizations.actions';
import * as SELECTORS from './organizations.selectors';

@Injectable()
export class OrganizationsFacade {
    selectedOrganization$: Observable<Organization | null> = this.store.select(SELECTORS.getSelectedOrganization);
    organizations$: Observable<Organization[]> = this.store.select(SELECTORS.selectAllOrganizations);
    organizationsLoading$: Observable<boolean> = this.store.select(SELECTORS.organizationsLoading);
    selectedOrganizationId$: Observable<number | null> = this.store.select(SELECTORS.getSelectedOrganizationId);

    constructor(private store: Store) {}

    fetchOrganizations(): void {
        this.store.dispatch(ACTIONS.fetchOrganizations());
    }

    selectOrganization(organizationId: string): void {
        this.store.dispatch(ACTIONS.selectOrganization({ organizationId }));
    }

    fetchOrganizationsByIds(organizationIds: number[]): void {
        this.store.dispatch(ACTIONS.fetchOrganizationsByIds({ organizationIds }));
    }
}
